import {
  includedOptions,
  maintenanceSLAOptions,
} from "@/common/const/filter-options";
import maintenanceTypeOptions from "@/common/const/filter-options/maintainanceType.options";
import { contractTermsOptions } from "@/common/const/types/index.const";
import { ResponseFormElementsType } from "@/common/types/forms/FormFieldsStrategy.type";

const hardwareResStrategy: ResponseFormElementsType[] = [
  {
    type: "text",
    attribute: "manufaturerName",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(?!\s*$).+/,
    patternMessage: "Manufacturer name cannot be empty",
  },
  {
    type: "select",
    attribute: "maintenanceStatus",
    required: true,
    options: includedOptions,
  },
  {
    type: "text",
    attribute: "productCode",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(?!\s*$).+/,
    patternMessage: "Product code cannot be empty",
  },
  {
    type: "text",
    attribute: "licenseName",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(?!\s*$).+/,
    patternMessage: "License name cannot be empty",
  },
  {
    type: "select",
    attribute: "purchaseType",
    required: true,
    options: [
      { label: "Resale", value: "Resale" },
      { label: "Rental", value: "Rental" },
    ],
  },
  {
    type: "select",
    attribute: "licenseStatus",
    required: true,
    options: includedOptions,
  },
  {
    type: "select",
    attribute: "contractTerm",
    required: true,
    options: [...contractTermsOptions],
  },
  {
    type: "select",
    attribute: "onSiteDeliveryIncluded",
    required: true,
    options: includedOptions,
  },
  {
    type: "select",
    attribute: "maintenanceType",
    required: true,
    options: maintenanceTypeOptions,
  },
  {
    type: "select",
    attribute: "onSiteInstallationIncluded",
    required: true,
    options: includedOptions,
  },
  {
    type: "select",
    attribute: "maintenanceSla",
    required: true,
    options: maintenanceSLAOptions,
  },
  {
    type: "select",
    attribute: "isLocalTax",
    required: true,
    options: includedOptions,
  },
  {
    type: "select",
    attribute: "dutiesIncluded",
    required: true,
    options: includedOptions,
  },
  {
    type: "text",
    attribute: "localTax",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/,
    patternMessage: "Enter a number between 0 and 100",
  },
  {
    type: "text",
    attribute: "leadTeam",
    required: true,
    inputClassElement: "border-gray-surface bg-white",
    pattern: /^\d{1,3}$/,
    patternMessage: "Lead time must be a number (days)",
  },

];
export default hardwareResStrategy;
